var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForwardArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "-0.5 -0.5 16 16",
    fill: "currentColor",
    id: "Caret-Right--Streamline-Phosphor",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.313375 7.972716796875 4.63189453125 14.654197265625c-0.363890625 0.363896484375 -0.9852597656250001 0.19740234375000001 -1.118455078125 -0.299689453125 -0.061810546875 -0.230701171875 0.004142578125 -0.47685937500000003 0.17302734374999998 -0.645744140625L9.896068359375 7.5 3.686466796875 1.2912363281249999c-0.363896484375 -0.363896484375 -0.19740234375000001 -0.9852597656250001 0.299689453125 -1.118455078125 0.230701171875 -0.06181640625 0.47685351562499995 0.00413671875 0.64573828125 0.173021484375l6.68148046875 6.68148046875c0.26128125 0.26098828125 0.26128125 0.6844453125000001 0 0.94543359375Z",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForwardArrow);
export default __webpack_public_path__ + "static/media/ForwardArrow.d57b1746b16ed1b456c979d2865a222c.svg";
export { ForwardRef as ReactComponent };